import { createFileRoute } from '@tanstack/react-router';

import { RecordEditorRoute } from '@/editor/RecordEditorRoute';
import { asRecordId } from '@/lib/brandedIds';

/**
 * Thin route-file shell for the record editor. The screen component
 * lives at `src/editor/record-editor-route.tsx`; this file extracts
 * the `recordId` URL param via `Route.useParams()` and passes it to
 * the screen as a prop.
 *
 * The prop-drilling shape (vs. having the screen read `useParams()`
 * directly) keeps the screen file free of a back-reference to this
 * shell — no circular import, and the screen is trivially renderable
 * in tests / Storybook by passing `recordId` directly.
 *
 * See `apps/client/docs/design.md` §"Route files are thin shells".
 */

export const Route = createFileRoute('/records/$recordId')({
  component: function RecordEditorRouteShell() {
    // TanStack Router param-parse boundary: `useParams()` returns a
    // primitive-string `recordId` per the route's `$recordId` segment;
    // brand it once here so the screen consumes a `RecordId` end-to-end.
    const { recordId } = Route.useParams();
    return <RecordEditorRoute recordId={asRecordId(recordId)} />;
  },
});
